import { gql } from "@apollo/client"

const GET_IMPORT_LOG_XLS_DOWNLOAD = gql`
  query($input: ImportLogDownloadInput!) {
    importLogDownload(input: $input) {
      filename
      url
      type
      queued
    }
  }
`

export { GET_IMPORT_LOG_XLS_DOWNLOAD }